module.exports = __webpack_public_path__ + "static/inspospotr-extraimg1@2x-min-46f3ba2efb4ef49a23bf83178f7080a9.png";